import React from "react";

class Input extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;

        const handleClick = e => {
            if(props.onOpen) {
                props.onOpen(this.props.value);
            }
            
            props.onTrigger(e);
        }

        const onInputChange = _.debounce(value => {
            if(props.onSearch) {
                props.onSearch(value);
            }
         
           // props.onUpdateState({options: props.options.filter(item => item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1)})
           // props.onUpdateState(value)
        }, 300);
        
        const handleChange = e => {
            onInputChange(e.target.value);

            if(e.target.value) {
                props.onUpdateState({inputValue: e.target.value, showSelected: false});
            } else {
                props.onUpdateState({inputValue: e.target.value, showSelected: true});
            }
        }

        const handleKeyPress = e => {
            if(e.key === "Backspace" && e.target.value === "") {
                props.onUpdateState({selected: {}});

                if(props.onClearSelected) {
                    props.onClearSelected();
                }
            }
        }

        const handleClear = () => {
            props.onUpdateState({inputValue: "", selected: {}});

            if(props.onClearSelected) {
                props.onClearSelected();
            }
        }

        const isSelectedActive = props.showSelectedInInput && props.state.selected.value && props.state.showSelected ? "selectedActive" : "";

        return (
            <React.Fragment>
                <div class={`selectedTrigger ${props.open ? "active" : ""} ${props.disabled ? "disabled" : ""}`} onClick={handleClick}>
                    {props.showSelectedInInput && props.state.showSelected && (props.renderSelected && props.state.selected.value ? props.renderSelected(props.state.selected) : <span class={`${isSelectedActive}`}>{props.state.selected.label}</span>)}
                    <input 
                        type="text" 
                        class={`${isSelectedActive} ${this.props.value !== "" ? "hasInput" : ""}`}
                        onChange={handleChange} 
                        placeholder={props.placeholder && ((props.showSelectedInInput && !props.state.selected.value) || !props.showSelectedInInput) ? props.placeholder : ""} 
                        onKeyDown={handleKeyPress}
                        value={this.props.value}
                    />
                    {props.searchIcon ? props.searchIcon : <i class="material-icons">arrow_drop_down</i>}
                    
                </div>
                {props.clearIcon && (props.state.selected || {}).value && (
                    <a class="clearIcon" onClick={handleClear}>
                        {props.clearIcon}
                    </a>
                )}
            </React.Fragment>
        )
    }
}

export default Input;